import { createRouter, createWebHistory } from 'vue-router'
import api from '@/api'
import LandingView from '../views/Page/Index.vue'
import TermsView from '../views/Page/Terms.vue'
import PrivacyView from '@/views/Page/Privacy.vue'
import CookiesView from '@/views/Page/Cookies.vue'
import ComplianceView from '@/views/Page/Compliance.vue'
import RegisterView from '../views/Page/SignUp.vue'
import SignIn from '../views/Page/SignIn.vue'
import ForgotPasswordView from '../views/Page/Forgot.vue'
import PasswordResetView from '../views/Page/Password.vue'
import PremiumView from '@/views/Page/Premium.vue' // La que acabamos de crear
import HomeView from '../views/HomeView.vue'
import ChatView from '../views/Social/Chat/ChatView.vue'
import ChatHistory from '../views/Social/Chat/ChatHistory.vue'
import UserProfile from '../views/Social/User/Profile.vue'

const routes = [
  {
    path: '/',
    name: 'Landing',
    component: LandingView
  },
  {
    path: '/terms',
    name: 'Termns',
    component: TermsView
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: PrivacyView
  },
  {
    path: '/cookies',
    name: 'cookies',
    component: CookiesView
  },
  {
    path: '/compliance',
    name: 'compliance',
    component: ComplianceView
  },
  {
    path: '/register',
    name: 'Register',
    component: RegisterView
  },
  {
    path: '/signin',
    name: 'Login',
    component: SignIn
  },
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: ForgotPasswordView
  },
  {
    path: '/password',
    name: 'reset-password',
    component: PasswordResetView
  },
  {
    path: '/settings/subscription',
    name: 'Subscription',
    component: PremiumView
  },
  {
    path: '/app',
    name: 'Discover',
    component: HomeView,
    meta: { requiresAuth: true } // Ruta protegida
  },
  {
    path: '/chat/:id',
    name: 'Chat',
    component: ChatView,
    props: true, // Pasa el :id como prop al componente
    meta: { requiresAuth: true } // Ruta protegida
  },
  {
    path: '/messages',
    name: 'Messages',
    component: ChatHistory,
    meta: { requiresAuth: true }
  },
   {
    path: '/profile',
    name: 'Profile',
    component: UserProfile,
    meta: { requiresAuth: true }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// --- GUARD DE SEGURIDAD ---
// Evita que usuarios sin Token entren a /app o /chat
router.beforeEach(async (to, from, next) => {
  const token = localStorage.getItem('token');
  const isAuthenticated = !!token;
  const localUser = JSON.parse(localStorage.getItem('user'));

  // 1. Guardia de Seguridad básica
  if (to.meta.requiresAuth && !isAuthenticated) {
    return next('/signin');
  }

  // 2. Refresco de datos en segundo plano
  if (isAuthenticated && localUser && to.meta.requiresAuth) {
    refreshUserData(localUser.id);
  }

  next();
});

// Ajustamos la función para que reciba el ID
const refreshUserData = async (userId) => {
  try {
    // Usamos el userId que viene del localStorage para la consulta
    const res = await api.get(`/users/${userId}`);
    const currentLocal = JSON.parse(localStorage.getItem('user'));

    if (!currentLocal) return;

    // Comparamos el campo is_premium
    if (res.data.is_premium !== currentLocal.is_premium) {
      const updatedUser = { ...currentLocal, is_premium: res.data.is_premium };
      localStorage.setItem('user', JSON.stringify(updatedUser));
    }
  } catch (e) {
    console.error("Error sincronizando status premium");
  }
};

export default router